export enum FileUploadStatusEnum {
  PENDING = 'PENDING',
  OK = 'OK',
  ERROR = 'ERROR',
}
